/* eslint-disable */
/**
 * @deprecated does nothing
 */
export default {
  attach: function () {},
  detach: function () {}
};